import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('negociacao', 'tipo-beneficio');

// Actions são ações que o resource terá.
// No exemplo abaixo, criamos uma ação 'list', que é um GET
// na url que aponta para a raíz da API
const tipoBeneficioActions = {
  listarAtivos: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true` },
};

// Exportamos então o recurso, que não passa de uma função que recebe um
// Vue.$resource como parâmetro e retorna um resource customizado.
// Vue.$resource tem a seguinte assinatura:
// function Resource(url, params, actions, options)

export default resource => resource(`${basePath}`, {}, tipoBeneficioActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/tipo-beneficio.js